import { createSlice } from '@reduxjs/toolkit';

const defaultBlogs = [
  { title: 'My First Blog', body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.', author: 'mario', id: 1, date: new Date().toISOString() },
  { title: 'Opening Party!', body: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', author: 'yoshi', id: 2, date: new Date().toISOString() },
  { title: 'Dragon Ball Z', body: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', author: 'mario', id: 3, date: new Date().toISOString() }
];

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('redux_blogs');
    if (serializedState === null) {
      return { blogs: defaultBlogs };
    }
    return { blogs: JSON.parse(serializedState) };
  } catch (err) {
    return { blogs: defaultBlogs };
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state.blogs);
    localStorage.setItem('redux_blogs', serializedState);
  } catch {
    // ignore write errors
  }
};

const initialState = loadState();

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    addBlog: (state, action) => {
      // Ensure the correct structure
      const newBlog = { ...action.payload, id: action.payload.id || Date.now(), date: new Date().toISOString() };
      state.blogs.unshift(newBlog); // Add to top
      saveState(state);
    },
    deleteBlog: (state, action) => {
      state.blogs = state.blogs.filter(blog => String(blog.id) !== String(action.payload));
      saveState(state);
    },
    editBlog: (state, action) => {
      const { id, title, body, author } = action.payload;
      const existingBlog = state.blogs.find(blog => String(blog.id) === String(id));
      if (existingBlog) {
        existingBlog.title = title;
        existingBlog.body = body;
        existingBlog.author = author;
        // Keep original date or update? Let's keep original date but maybe add 'updatedAt' later.
      }
      saveState(state);
    }
  }
});

export const { addBlog, deleteBlog, editBlog } = blogSlice.actions;
export default blogSlice.reducer;
